import {Loader} from '@googlemaps/js-api-loader';

const loader = new Loader({
    apiKey: process.env.REACT_APP_GOOGLE_MAP_API_KEY,
    libraries: ['places'],
});

export const loadGoogleMap = async () => await loader.load();
